/** The one sentence about a rescoring owed, shared by the register and the risk's own page.
 *
 * RSK-02, on the row it is about. The score is unchanged and a judgement is owed — and the sentence
 * says the product has not made it, because that is the whole distinction between a review and a
 * silent rescoring. It is one component so the two screens cannot describe the same fact in two
 * ways (design rule 7).
 */

import own from "./Risks.module.css";

export function RescoringNote() {
  return (
    <p className={own.rescore} data-testid="needs-rescoring">
      <strong>This needs rescoring.</strong> The scale it was scored on has been replaced. The score
      above is left exactly as it was — it was read against the old scale and still means what it
      meant — and choosing a position on the new one is a judgement EmitIQ does not make for you.
    </p>
  );
}
